import { AssessmentsContentBlock, FollowUpContentBlock, MapSessionFormFields, SectionContainerDivider } from '../../components';

// initial progress
export const Plan: React.VFC = () => {

  return (
    <>
      <AssessmentsContentBlock showIntake />
      <SectionContainerDivider />

      <MapSessionFormFields
        namespace="initialProgress"
        sectioned
      />

      <FollowUpContentBlock />
    </>
  );
};
